"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});require('./markdown.module.css');const e="_markdownContainer_dtpxk_1",n={markdownContainer:e};exports.default=n;exports.markdownContainer=e;
//# sourceMappingURL=markdown.module.css.cjs.map
